import { AfterViewInit, Component, EventEmitter, Injectable, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  NgbCalendar,
  NgbCalendarIslamicUmalqura,
  NgbDateStruct,
  NgbDatepickerI18n
} from '@ng-bootstrap/ng-bootstrap';

import { TranslateService } from '@ngx-translate/core';
import { IDate } from '../../models/models';

const WEEKDAYS = ['ن', 'ث', 'ر', 'خ', 'ج', 'س', 'ح'];
const MONTHS = ['محرم', 'صفر', 'ربيع الأول', 'ربيع الآخر', 'جمادى الأولى', 'جمادى الآخرة', 'رجب', 'شعبان', 'رمضان', 'شوال',
  'ذو القعدة', 'ذو الحجة'];

@Injectable()
export class IslamicI18n extends NgbDatepickerI18n {

  getWeekdayShortName(weekday: number) {
    return WEEKDAYS[weekday - 1];
  }

  getMonthShortName(month: number) {
    return MONTHS[month - 1];
  }

  getMonthFullName(month: number) {
    return MONTHS[month - 1];
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}

@Component({
  selector: 'app-datepicker-umalqura',
  templateUrl: './datepicker-umalqura.component.html',
  styleUrls: ['./datepicker-umalqura.component.scss'],
  providers: [
    { provide: NgbCalendar, useClass: NgbCalendarIslamicUmalqura },
    { provide: NgbDatepickerI18n, useClass: IslamicI18n }
  ],
  outputs: ['onDateSelect'],
})
export class DatepickerUmalquraComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void {
    if (this.dateValue && this.dateValue.year && this.dateValue.month && this.dateValue.day)
      this.form.controls['date'].setValue(this.dateValue)
  }

  model: NgbDateStruct;
  public onDateSelect = new EventEmitter()

  @Input() minDate: NgbDateStruct = { day: 1, month: 1, year: 1318 };
  @Input() maxDate: NgbDateStruct = { day: 30, month: 12, year: 1500 };
  @Input() isRequired: boolean = false
  @Input() isDisabled: boolean = false
  @Input() label: string
  @Input() showIsRequiredSpan: boolean = false
  @Input() placeHolder: string = 'yyyy-mm-dd';
  
  @Input() value: IDate
  private dateValue: NgbDateStruct

  form: FormGroup = new FormGroup({
    date: new FormControl(''),
  })

  constructor(private calendar: NgbCalendar, private translate: TranslateService) {
    if (this.isRequired)
      this.form.controls['date'].setValidators(Validators.required)
  }

  ngOnInit(): void {

    if (this.value && this.value.day && this.value.month && this.value.year) {
      this.dateValue = {
        day: parseInt(this.value.day),
        month: parseInt(this.value.month),
        year: parseInt(this.value.year)
      } as NgbDateStruct;
    }
  }

  public isFormValid(): boolean {
    var isValid = true

    if (this.isRequired) {
      if (!this.form.controls['date'].value || !this.form.controls['date'].value.day || !this.form.controls['date'].value.month || !this.form.controls['date'].value.year) {
        isValid = false
        for (let control in this.form.controls) {
          this.form.controls[control].markAsTouched()
        }
      }
    }

    return isValid
  }

  selectToday() {
    this.model = this.calendar.getToday();
  }

  selectDate() {
    if (this.form.controls['date'].value && this.form.controls['date'].value.day && this.form.controls['date'].value.month && this.form.controls['date'].value.year) {
      //this.form.reset()
      this.onDateSelect.emit({
        value: this.form.controls['date'].value,
      })
    }
  }

  click() {

    // if (this.form && this.form.length) {
    //     for (let i = 0; i < this.form.length; i++) {
    //         if (this.form[i]) {
    //             this.form[i].datePicker.close()
    //         }
    //     }
    // }

    // this.datePicker.toggle()
    // this.onClick.emit({})
  }
  resetDate() {
    this.form.controls["date"].setValue(null);
    this.form.reset();
  }

}


